import React, { useState, useEffect, useRef } from "react";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import "./Stripe.css";
import { BiLinkExternal } from "react-icons/bi";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageSubHeading from "../../../../components/CommonComponents/MessageSubHeading";
import { Link } from "react-router-dom";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import AdminCustomSelect from "../../../../components/CommonComponents/AdminCustomSelect";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import AdminCustomPasswordInput from "../../../../components/CommonComponents/AdminCustomPasswordInput";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import DeviceSelector from "../../../../components/PaymentComponents/DeviceSelector";

function Stripe() {
  const { fetchRequest } = useMyContext()
  const [formData, setFormData] = useState({})
  const [formDataError, setFormDataError] = useState({})
  const [loading, setLoading] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);

  // Supported devices from backend helper
  const [supportedDevices, setSupportedDevices] = useState(['web', 'Android', 'iOS', 'TV']);

  const combinedRef = useRef({});

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    }
    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (value == 1) {
        setFormDataError((prev) => ({
          ...prev,
          test_secret_key: "",
          test_publishable_key: ""
        }));
      }
      if (value == 0)
        setFormDataError((prev) => ({
          ...prev,
          live_secret_key: "",
          live_publishable_key: ""
        }));
    }
  };

  const handleDeviceChange = (updatedDevices) => {
    // Filter only valid devices and ensure it's an array
    const validDevices = Array.isArray(updatedDevices)
      ? updatedDevices.filter(device => supportedDevices.includes(device))
      : [];

    console.log('Device change:', { updatedDevices, validDevices, supportedDevices });

    setFormData((prev) => ({
      ...prev,
      supported_devices: validDevices
    }));
  };

  const formValidation = () => {
    let formIsValid = true;

    // Validate supported devices
    if (!formData?.supported_devices || !Array.isArray(formData.supported_devices) || formData.supported_devices.length === 0) {
      toast.warning('Please select at least one supported device.');
      formIsValid = false;
    }

    if (formData?.payment_mode == 0) {
      if (!formData?.test_publishable_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_publishable_key: "Test Publish cannot be empty.",
        }));
        combinedRef.current['test_publishable_key'].focus()
        formIsValid = false;
      }
      if (!formData?.test_secret_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_secret_key: "Test Secret cannot be empty.",
        }));
        combinedRef.current['test_secret_key'].focus()
        formIsValid = false;
      }
    }
    if (formData?.payment_mode == 1 && !formData?.live_publishable_key && !formData?.live_secret_key) {
      if (!formData?.live_publishable_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_publishable_key: "Live Publish cannot be empty.",
        }));
        combinedRef.current['live_publishable_key'].focus()
        formIsValid = false;
      }
      if (!formData?.live_secret_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_secret_key: "Live Secret cannot be empty.",
        }));
        combinedRef.current['live_secret_key'].focus()
        formIsValid = false;
      }
    }

    return formIsValid;
  }

  const handleStore = async () => {
    console.log('Form data before validation:', formData);
    if (formValidation()) {
      setLoading(true)
      const dataToSend = {
        ...formData,
        supported_devices: JSON.stringify(formData.supported_devices || [])
      };
      console.log('Data being sent:', dataToSend);

      await fetchRequest({
        method: 'POST',
        url: `${process.env.REACT_APP_Baseurl}/admin/stripe_payment/store`,
        params: {},
        data: dataToSend,
      })
        .then(response => {
          if (response?.status) {
            toast.success(response?.message)
            setWithOutRefresh((prev) => !prev)
          }
        }).catch((error => {
          toast.error(error?.response?.data?.message)
        })).finally(() => {
          setLoading(false)
        })
    }
  }

  useEffect(async () => {
    setShowOverlay(true)

    // Fetch supported devices from backend
    try {
      const deviceResponse = await fetchRequest({
        method: 'GET',
        url: `${process.env.REACT_APP_Baseurl}/admin/supported-devices`,
        params: {},
        data: {},
      });

      if (deviceResponse?.status && deviceResponse?.data) {
        setSupportedDevices(deviceResponse.data);
      }
    } catch (error) {
      console.warn('Using default supported devices:', error);
    }

    await fetchRequest({
      method: 'GET',
      url: `${process.env.REACT_APP_Baseurl}/admin/stripe_payment/index`,
      params: {},
      data: {},
    })
      .then(response => {
        if (response?.status) {
          const stripeData = response?.stripe_payment;
          let deviceArray = ['web', 'Android']; // default

          // Parse supported_devices if it exists
          if (stripeData?.supported_devices) {
            try {
              const parsedDevices = typeof stripeData.supported_devices === 'string'
                ? JSON.parse(stripeData.supported_devices)
                : stripeData.supported_devices;
              deviceArray = Array.isArray(parsedDevices) ? parsedDevices : [];
              console.log('Loaded devices:', deviceArray);
            } catch (error) {
              console.warn('Invalid supported_devices format:', stripeData.supported_devices);
              deviceArray = [];
            }
          }

          setFormData((prev) => ({
            ...prev,
            ...stripeData,
            supported_devices: deviceArray
          }));
        }
      }).catch((error => {
        toast.error(error?.response?.data?.message)
      })).finally(() => {
        setShowOverlay(false)
      })
  }, [withOutRefresh]);

  return (
    <>

      {showOverlay && (<Response_Processing />)}
      <AdminBackNavigation id="playout-backbtn" path="/payment_settings" text="Back" />
      <AdminSaveHeader heading={"Stripe Payment"} saveText={"Update Stripe"} saveMethod={handleStore} loading={loading} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Stripe Configuration" />
            <Link to="https://stripe.com/docs" target="_blank" className="d-inline-flex  align-items-center gap-2 p-2 rounded-2 shadow mb-4">
              <MessageSubHeading text="https://stripe.com/docs" noMargin />
              <BiLinkExternal className="text-dark ms-2" />
            </Link>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-7 col-md-7 pe-2">
                <MessageLabel text={"Enable Payment Mode"} />
              </div>
              <div className="col-3 col-md-3 ps-2 text-end">
                <AdminCustomSelect className="payment-mode-custom-select " name="payment_mode" value={formData?.payment_mode} onChange={handleInput} ref={(el) => (combinedRef.current.payment_mode = el)} options={[{ name: "TEST", value: 0 }, { name: "LIVE", value: 1 }]} error={""} defaultOptionName={""} />
              </div>
            </div>
            <MessageLabel text={"Stripe Label"} className="" />
            <AdminCustomInput type="text" name="stripe_label" value={formData?.stripe_label} onChange={handleInput} placeHolder={"Stripe label"} ref={(el) => (combinedRef.current.stripe_label = el)} error={formDataError?.stripe_label} />
          </Wrapper>
          <Wrapper>
            <DeviceSelector
              selectedDevices={formData?.supported_devices || []}
              onDeviceChange={handleDeviceChange}
              gatewayName="stripe"
              availableDevices={supportedDevices}
              showDescriptions={true}
              label="Supported Devices"
              showSelectAll={true}
              className=""
              cardStyle="default"
              showDeviceStats={true}
            />
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text="Stripe Key Details (LIVE)" />
            <MessageLabel text={"Live Publishable Key"} className="" />
            <AdminCustomPasswordInput name="live_publishable_key" value={formData?.live_publishable_key} onChange={handleInput} placeHolder={"live publishable key"} ref={(el) => (combinedRef.current.live_publishable_key = el)} error={formDataError?.live_publishable_key} />
            <MessageLabel text={"Live Secret Key"} className="" />
            <AdminCustomPasswordInput name="live_secret_key" value={formData?.live_secret_key} onChange={handleInput} placeHolder={"live secret key"} ref={(el) => (combinedRef.current.live_secret_key = el)} error={formDataError?.live_secret_key} />
            <MessageLabel text={"Live Webhook Secret"} className="" />
            <AdminCustomPasswordInput name="live_webhook_secret" value={formData?.live_webhook_secret} onChange={handleInput} placeHolder={"live webhook secret"} ref={(el) => (combinedRef.current.live_webhook_secret = el)} error={formDataError?.live_webhook_secret} />
          </Wrapper>
          <Wrapper>
            <MessageHeading text="Stripe Key Details (TEST)" />
            <MessageLabel text={"Test Publishable Key"} className="" />
            <AdminCustomPasswordInput name="test_publishable_key" value={formData?.test_publishable_key} onChange={handleInput} placeHolder={"test publishable key"} ref={(el) => (combinedRef.current.test_publishable_key = el)} error={formDataError?.test_publishable_key} />
            <MessageLabel text={"Test Secret Key"} className="" />
            <AdminCustomPasswordInput name="test_secret_key" value={formData?.test_secret_key} onChange={handleInput} placeHolder={"test secret key"} ref={(el) => (combinedRef.current.test_secret_key = el)} error={formDataError?.test_secret_key} />
            <MessageLabel text={"Test Webhook Secret"} className="" />
            <AdminCustomPasswordInput name="test_webhook_secret" value={formData?.test_webhook_secret} onChange={handleInput} placeHolder={"test webhook secret"} ref={(el) => (combinedRef.current.test_webhook_secret = el)} error={formDataError?.test_webhook_secret} />
          </Wrapper>
          <Wrapper>
            <MessageLabel text={"Stripe Webhooks"} className="" />
            <AdminCustomInput type="text" value={`${process.env.REACT_APP_Baseurl}/Front-End/stripe-webhook`} disabled />
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={"Update Stripe"} loading={loading} />
      </FormContainer>
    </>
  );
}

export default Stripe;
